
import Vue from "vue";
import { Component } from "vue-property-decorator";
import VueRecaptcha from "vue-recaptcha";
import { URL_EMAIL_SERVICE as URL } from "../constants";

@Component({
  name: "FormularioContato",

  components: {
    "vue-recaptcha": VueRecaptcha,
  },
})
export default class FormularioContato extends Vue {
  dialogTrabalhe: boolean = false;
  dialogTrabalheMD: boolean = false;
  nome: string = "";
  instituicao: string = "";
  telefone: any = "";
  email: string = "";
  select: any = null;
  assunto: string = "";
  mensagem: string = "";
  faleConosco: any = {};
  aberto: any = null;
  resposta: any = null;
  dialogo: boolean = false;
  erro: boolean = false;

  get form(): Vue & { validate: () => boolean; reset: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  get recaptcha(): Vue & { reset: () => boolean } {
    return this.$refs.recaptcha as Vue & { reset: () => boolean };
  }

  get isPequeno() {
    if (
      this.$vuetify.breakpoint.name == "xs" ||
      this.$vuetify.breakpoint.name == "sm"
    ) {
      return true;
    } else {
      return false;
    }
  }

  mostrar() {
    if (
      this.$vuetify.breakpoint.name == "xs" ||
      this.$vuetify.breakpoint.name == "sm"
    ) {
      this.aberto = !this.aberto;
    }
  }

  valido(recaptchaToken: any) {
    this.resposta = recaptchaToken;
  }

  async enviar() {
    try {
      if (!this.form.validate() || this.resposta == null) {
        this.erro = true;
        return;
      }

      this.faleConosco = {
        nome: this.nome,
        instituicao: this.instituicao,
        telefone: this.telefone,
        email: this.email,
        assunto: this.assunto,
        mensagem: this.mensagem,
        gRecaptchaResponse: this.resposta,
      };

      // let result = await this.$http.post(URL + "ws/sitenserv/contato/", {
      //   faleConosco: this.faleConosco,
      // });

      this.dialogo = true;
      this.erro = false;
      this.form.reset();
      this.recaptcha.reset();
      this.resposta = null;
    } catch (error) {
      console.log("Error: " + error);
    }
  }
}
